import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "accessoire-form base-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Choix des accessoires", -1)

import CategorieForm from './CategorieForm.vue';
import { IProduct, onlyUnique } from '@/model/Product';
import { computed } from '@vue/reactivity';
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  accessoires: { type: Array as PropType<IProduct[]>, default: () => [] },
  lame: { type: Object as PropType<IProduct | undefined>, default: () => undefined },
},
  emits: ['update', 'updateInfo'],
  setup(__props, { emit: emits }) {

const props = __props



const categories = computed(() => {
  return props.accessoires.map(a => a.sous_categorie).filter(onlyUnique)
})



const update = (value: any) => {
  emits('update', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (categorie) => {
      return (_openBlock(), _createBlock(CategorieForm, {
        key: categorie,
        accessoires: __props.accessoires,
        categorie: categorie,
        lame: __props.lame,
        onUpdate: _cache[0] || (_cache[0] = ($event: any) => (update($event))),
        onUpdateInfo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateInfo', $event)))
      }, null, 8, ["accessoires", "categorie", "lame"]))
    }), 128))
  ]))
}
}

})